import { Routes } from '@angular/router';
import { requireAuth } from '@nabotavle/auth';

export const routes: Routes = [
  { path: 'login', title: 'Logg inn — Nabotavle adminkonsoll', loadComponent: () => import('./login/login-page').then((m) => m.AdminLoginPage) },
  // Pre-login pages reached from the login form / the mailed reset link — outside the auth guard.
  { path: 'glemt-passord', title: 'Glemt passord — Nabotavle adminkonsoll', data: { app: 'adminkonsoll' }, loadComponent: () => import('@nabotavle/auth/pages').then((m) => m.GlemtPassord) },
  { path: 'nytt-passord', title: 'Nytt passord — Nabotavle adminkonsoll', data: { app: 'adminkonsoll' }, loadComponent: () => import('@nabotavle/auth/pages').then((m) => m.NyttPassord) },
  {
    // The console requires a session (and AAL3, enforced by the API). Unauthenticated
    // users are sent to /login, which performs the superuser step-up.
    path: '',
    canMatch: [requireAuth],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'portefolje' },
      {
        path: 'portefolje',
        title: 'Portefølje — Nabotavle adminkonsoll',
        loadComponent: () => import('./portefolje/portefolje').then((m) => m.Portefolje),
      },
      {
        path: 'opprett',
        title: 'Opprett sameie — Nabotavle adminkonsoll',
        loadComponent: () => import('./opprett/opprett').then((m) => m.Opprett),
      },
      {
        path: 'lag/:id',
        title: 'Lag — Nabotavle adminkonsoll',
        loadComponent: () => import('./lag-detalj/lag-detalj').then((m) => m.LagDetalj),
      },
      {
        path: 'import/:id',
        title: 'Importer — Nabotavle adminkonsoll',
        loadComponent: () => import('./import/import').then((m) => m.ImportLag),
      },
      {
        path: 'drift',
        title: 'Drift & innsikt — Nabotavle adminkonsoll',
        loadComponent: () => import('./drift/drift').then((m) => m.Drift),
      },
      {
        path: 'revisjonslogg',
        title: 'Revisjonslogg — Nabotavle adminkonsoll',
        loadComponent: () => import('./revisjonslogg/revisjonslogg').then((m) => m.Revisjonslogg),
      },
      {
        path: 'epostlogg',
        title: 'E-postlogg — Nabotavle adminkonsoll',
        loadComponent: () => import('./epostlogg/epostlogg').then((m) => m.Epostlogg),
      },
      {
        path: 'epost-maler',
        title: 'E-postmaler — Nabotavle adminkonsoll',
        loadComponent: () => import('./epost-maler/epost-maler').then((m) => m.EpostMaler),
      },
      {
        path: 'brevo',
        title: 'Brevo — Nabotavle adminkonsoll',
        loadComponent: () => import('./brevo/brevo').then((m) => m.Brevo),
      },
      {
        path: 'konto',
        title: 'Min konto — Nabotavle adminkonsoll',
        loadComponent: () => import('./konto/konto').then((m) => m.Konto),
      },
      {
        path: 'sms-logg',
        title: 'SMS-logg — Nabotavle adminkonsoll',
        loadComponent: () => import('./sms-logg/sms-logg').then((m) => m.SmsLogg),
      },
    ],
  },
  // Unbuilt nav targets fall back to the portefølje rather than 404.
  { path: '**', redirectTo: 'portefolje' },
];
